// extracted by mini-css-extract-plugin
export default {"subtitle":"WhDs8u1J6d81WWeimKFEJw=="};